/** Keep app overlays before the legacy ad-cleanup boundary. */
export function getPortalRoot(): HTMLElement {
  const existing = document.getElementById('app-overlays');
  if (existing) return existing;
  const root = document.createElement('div');
  root.id = 'app-overlays';
  document.body.insertBefore(root, document.getElementById('last_element'));
  return root;
}
